// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 85 ? "pages-step1" : chunkId) + "." + {"85":"b30a13fd","872":"7b3ace83"}[chunkId] + ".chunk.js";
};